export enum ErrorsEnum {
    API_ERROR = "API Error",
    FILE_ERROR = "Server returned an error",
    SIZE_ERROR = "File size too large",
    AUTH_ERROR = "Attachment is not authorized",
    RLSO_NONE_CHECKED_ERROR = "error.select-one-record",
    RLSO_INVALID_RAC_OPTION = "error.does-not-exist",
    RLSO_TECHNICAL_ERROR = "error.technical-error"
}